//import AsyncStorage from '@react-native-async-storage/async-storage';
import React from 'react';
import posthog, { PostHog, type PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

type WithOptionalChildren<T> = T & {
    children?: React.ReactNode | undefined;
};
type PostHogProviderProps = {
    client: PostHog;
    apiKey?: never;
    options?: never;
} | {
    apiKey: string;
    options?: Partial<PostHogConfig>;
    client?: never;
};

const BEPostHogProvider = (props:WithOptionalChildren<PostHogProviderProps>) => {
    return (
      <PostHogProvider { ...props }>
        {props.children}
      </PostHogProvider>
    )
}
let client: PostHog | undefined = undefined

const generateClient = (api_key?:string, options?:PostHogConfig) => {
  client = posthog.init(api_key??'phc_VOgl6v8COVPyu4AERusWqK8HSD2dDju99qSa70G4nLl', {
    api_host:'https://us.i.posthog.com',
    autocapture: false,
    capture_pageview: false,
    capture_performance: false,
    ...options
  });
  return client
}

const EventActions = {
  identify: async(player_id:string, props?:any) => {
    if(!client){ return }
    try {
      await posthog.identify(player_id, props)
      return true
    } catch (e) {
      console.log(e);
      return false
    }
  },
  captureScreen: async(screen:string, props?: any) => {
    if(!client){ return }
    try {
      await posthog.capture('$screen', { screen, ...props });
      return true
    } catch (e) {
      console.log(e);
      return false
    }
  },
  captureEvent: async(event_name:string, props?:any) => {
    if(!client){ return }
    try {
      await posthog.capture(event_name, props)
      return true
    } catch (e) {
      console.log(e)
      return false
    }
  }
}

const RecordingActions = {
  startRecording: async() => {
    try {
      console.log('STARTING TO RECORD!!!!');
        await posthog.startSessionRecording();
        console.log('DONE!!')
        return true
    } catch (e) {
        console.log(e);
        return false
    }
  },
  stopRecording: async() => {
    try {
      console.log('stopped')
      await posthog.stopSessionRecording();
      return true
    } catch (e) {
      console.log(e)
      return false
    }
  },
  recordClip: async(seconds:number) => {
      const started = await RecordingActions.startRecording();
      console.log(started);
      if(!started){ return }
      setTimeout(() => {
          RecordingActions.stopRecording()
      }, seconds*1000);
  }
}

export default {
  source: 'web',
  BEPostHogProvider,
  generateClient,
  RecordingActions,
  EventActions
}